import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

var map;
const { AmCharts } = global;

// to render table of channels
class ListingTable extends Component {
    render() {
        var item = this.props.item;
        var broadcastListing = null;
        if(item != null){
            return (
                <table className="table">
                    <tbody>
                        {Object.keys(item).map(function (key) {
                            var itemChild = item[key].childrenPosts;
                            // console.log('item network: ', item[key].network);
                            // console.log('index: ', item[key].network.indexOf("Roku"), item[key].network.indexOf("YouTube (Joseph Prince Ministries - USA)"), item[key].network.indexOf("Apple TV"));
                            if(item[key].network.indexOf("Roku")==0) {
                                broadcastListing = <a href="http://josephprince.org/roku" target="_blank">{item[key].network}&nbsp;<i className="fa  fa-external-link"></i></a>;
                            } else if (item[key].network.indexOf("tv")>1) {
                                broadcastListing = <a href="http://josephprince.org/on-demand" target="_blank">{item[key].network}&nbsp;<i className="fa  fa-external-link"></i></a>;
                            } else if (item[key].network.indexOf("YouTube (Joseph Prince Ministries - USA)")==0) {
                                broadcastListing = <a href="http://josephprince.org/youtube" target="_blank">{item[key].network}&nbsp;<i className="fa  fa-external-link"></i></a>;
                            } else if (item[key].network.indexOf("Apple TV")==0) {
                                broadcastListing = <a href="http://josephprince.org/appletv" target="_blank">{item[key].network}&nbsp;<i className="fa  fa-external-link"></i></a>;
                            } else if (item[key].network.indexOf("Amazon Fire TV")==0) {
                                broadcastListing = <a href="http://josephprince.org/firetv" target="_blank">{item[key].network}&nbsp;<i className="fa  fa-external-link"></i></a>;
                            } else if (item[key].network.indexOf("Español")>1) {
                                broadcastListing = <a href="https://www.youtube.com/JosephPrinceEspanol" target="_blank">{item[key].network}&nbsp;<i className="fa  fa-external-link"></i></a>;
                            } else if (item[key].network.indexOf("Indonesia")>1) {
                                broadcastListing = <a href="https://www.youtube.com/JosephPrinceBahasaIndonesia" target="_blank">{item[key].network}&nbsp;<i className="fa  fa-external-link"></i></a>;
                            } else if (item[key].network.indexOf("Khmer")>1) {
                                broadcastListing = <a href="https://www.youtube.com/channel/UC6SoRiYd4v4x5-vZq_7fZtQ" target="_blank">{item[key].network}&nbsp;<i className="fa  fa-external-link"></i></a>;
                            } else {
                                broadcastListing = item[key].network;
                            }
                            return (
                                <tr key={key}>
                                    <td className="broadcast__listings__heading">
                                        <strong>
                                            { broadcastListing }
                                        </strong>
                                      </td>
                                      <td>
                                        {Object.keys(itemChild).map(function (childKey) {
                                            return (
                                                <div className="row mb-1" key={childKey}>
                                                    <div className="col-12 col-md-4">{itemChild[childKey].channel}</div>
                                                    <div className="col-6 col-md-4">{itemChild[childKey].day}</div>
                                                    <div className="col-6 col-md-4">{itemChild[childKey].timings}</div>
                                                </div>
                                            )
                                        })}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            )
        }
        else {
            return (
                <div></div>
            )
        }
    }
}

class BroadcastListings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDropdownName: "All Listings",
            posts: null,
            postsByState: null,
            // postsByUSCity: null,
            clickOnState: false,
            stateID: null,
            selectCountryValue: null,
            selectStateValue: null,
            isLoading: true,
            isLoadingState: true,
        };

        // this.handleCountryChange = this.handleCountryChange.bind(this);
        // this.handleStateChange = this.handleStateChange.bind(this);
        // this.handleSubmit = this.handleSubmit.bind(this);
        // this.selectOnMap = this.selectOnMap.bind(this);
        this.handleDropdownClick = this.handleDropdownClick.bind(this);
    }

    // get results by state (AJAX)
    getResultsByState(selectStateValue){

        var _self = this;
        _self.setState({isLoadingState: true});

        $.ajax({
            url: "/watch/broadcast-listings/state/" + selectStateValue,
            type: "GET",
            success: function(data){
                _self.setState({postsByState: data.posts, isLoadingState: false});
            },
            error: function(data){
                _self.setState({postsByState: null, isLoadingState: false});
            },
        });

        return null;
    }

    // get results by state (AJAX)
    getResultsByUSCity(){

        var _self = this;
        _self.setState({isLoading: true});

        $.ajax({
            url: "/watch/broadcast-listings/city",
            type: "GET",
            success: function(data){
                var postsByUSCity = data.posts;
                var posts = _self.state.posts;

                // insert US City in the new position https://jpm.nolt.io/163
                posts.splice(2, 0, {"id": 999, "title": "US City", "childrenPosts": postsByUSCity});

                // insert Locate By US Map in the new position https://jpm.nolt.io/163
                // posts.splice(3, 0, {"id": "#usmap", "title": "Locate By US Map"});

                _self.setState({posts: posts, isLoading: false});
            },
            error: function(data){
                // _self.setState({postsByUSCity: null});
            }
        });

        return null;
    }

    // get all broadcast listings (AJAX)
    getAllBroadcastListings(){
        var _self = this;
        _self.setState({isLoading: true});

        $.ajax({
            url: "/watch/broadcast-listings/all",
            type: "GET",
            success: function(data){
                _self.setState({posts: data.posts}, _self.getResultsByUSCity());
            },
            error: function(data){
                _self.setState({posts: null});
            }
        });

        return null;
    }

    // amcharts generate map code
    // reference: https://www.amcharts.com/kbase/display-state-abbreviations-as-labels-over-us-map/
    mountMap(){
        var _self = this;
        map = AmCharts.makeChart( "chartdiv", {
            "type": "map",
            "theme": "jpm",
            "colorSteps": 1,

            "dataProvider": {
                "map": "usaLow",
                "areas": [ {
                    id: "US-AL",
                    value: 100
                }, {
                    id: "US-AK",
                    value: 100
                }, {
                    id: "US-AZ",
                    value: 100
                }, {
                    id: "US-AR",
                    value: 100
                }, {
                    id: "US-CA",
                    value: 100
                }, {
                    id: "US-CO",
                    value: 100
                }, {
                    id: "US-CT",
                    value: 100
                }, {
                    id: "US-DC",
                    value: 100
                }, {
                    id: "US-DE",
                    value: 100
                }, {
                    id: "US-FL",
                    value: 100
                }, {
                    id: "US-GA",
                    value: 100
                }, {
                    id: "US-HI",
                    value: 100
                }, {
                    id: "US-ID",
                    value: 100
                }, {
                    id: "US-IL",
                    value: 100
                }, {
                    id: "US-IN",
                    value: 100
                }, {
                    id: "US-IA",
                    value: 100
                }, {
                    id: "US-KS",
                    value: 100
                }, {
                    id: "US-KY",
                    value: 100
                }, {
                    id: "US-LA",
                    value: 100
                }, {
                    id: "US-ME",
                    value: 100
                }, {
                    id: "US-MD",
                    value: 100
                }, {
                    id: "US-MA",
                    value: 100
                }, {
                    id: "US-MI",
                    value: 100
                }, {
                    id: "US-MN",
                    value: 100
                }, {
                    id: "US-MS",
                    value: 100
                }, {
                    id: "US-MO",
                    value: 100
                }, {
                    id: "US-MT",
                    value: 100
                }, {
                    id: "US-NE",
                    value: 100
                }, {
                    id: "US-NV",
                    value: 100
                }, {
                    id: "US-NH",
                    value: 100
                }, {
                    id: "US-NJ",
                    value: 100
                }, {
                    id: "US-NM",
                    value: 100
                }, {
                    id: "US-NY",
                    value: 100
                }, {
                    id: "US-NC",
                    value: 100
                }, {
                    id: "US-ND",
                    value: 100
                }, {
                    id: "US-OH",
                    value: 100
                }, {
                    id: "US-OK",
                    value: 100
                }, {
                    id: "US-OR",
                    value: 100
                }, {
                    id: "US-PA",
                    value: 100
                }, {
                    id: "US-RI",
                    value: 100
                }, {
                    id: "US-SC",
                    value: 100
                }, {
                    id: "US-SD",
                    value: 100
                }, {
                    id: "US-TN",
                    value: 100
                }, {
                    id: "US-TX",
                    value: 100
                }, {
                    id: "US-UT",
                    value: 100
                }, {
                    id: "US-VT",
                    value: 100
                }, {
                    id: "US-VA",
                    value: 100
                }, {
                    id: "US-WA",
                    value: 100
                }, {
                    id: "US-WV",
                    value: 100
                }, {
                    id: "US-WI",
                    value: 100
                }, {
                    id: "US-WY",
                    value: 100
                } ]
            },

            "areasSettings": {
                "autoZoom": true
            },

            "imagesSettings": {
                "labelPosition": "middle",
                "labelFontSize": 12
            },

            "listeners": [{
                "event": "clickMapObject",
                "method": function(event) {
                    if(event.mapObject.id){
                        var stateID = event.mapObject.id.substring(3,5);
                        _self.setState({stateID: stateID, clickOnState: true});
                        _self.getResultsByState(stateID);
                        _self.scrollToMap();
                    }

                }
            }]

        } );

        // set up a longitude exceptions for certain areas
        var longitude = {
            "US-CA": -130,
            "US-FL": 120,
            "US-TX": 1,
            "US-LA": 40
        };

        var latitude = {
            "US-AK": -85,
            "US-MD": 65
        };

        setTimeout(function () {
            // iterate through areas and put a label over center of each
            map.dataProvider.images = [];
            for(var x in map.dataProvider.areas ) {
                var area = map.dataProvider.areas[ x ];
                area.groupId = area.id;
                var image = new AmCharts.MapImage();
                image.latitude = latitude[ area.id ] || map.getAreaCenterLatitude( area );
                image.longitude = longitude[ area.id ] || map.getAreaCenterLongitude( area );
                image.label = area.id.split('-').pop();
                image.title = area.title;
                image.linkToObject = area;
                image.groupId = area.id;
                map.dataProvider.images.push( image );
            }
            map.validateData();
            //console.log(map.dataProvider);
        }, 100)

    }

    // // handle form
    // handleCountryChange(event){
    //     this.setState({selectCountryValue: event.target.value})
    // }

    // update and scroll to map
    // handleStateChange(event){
    //     this.setState({selectStateValue: event.target.value});
    //     this.setState({stateID: event.target.value});
    //     this.selectOnMap(event.target.value);
    // }

    // handleSubmit(event) {
    //     event.preventDefault();
    //     if(this.state.selectCountryValue == "USA"){
    //         this.selectOnMap(this.state.selectStateValue);
    //     }
    //     else {
    //         // else show international
    //         // show tab
    //         $('#tablist a:contains("International")').tab('show');
    //     }
    // }

    scrollToMap(){
        // scroll to map
        $('html,body').animate({
            scrollTop: $("#chartdiv").offset().top
        });
    }

    // selectOnMap(selectStateValue){
    //     // get search results by AJAX
    //     this.getResultsByState(selectStateValue);
    //
    //     // show tab
    //     $('#tablist a[href="#usmap"]').tab('show');
    //
    //     console.log(selectStateValue);
    //
    //     // highlight state on map
    //     var mapObject = map.getObjectById('US-' + selectStateValue);
    //     map.clickMapObject(mapObject);
    //
    //     this.scrollToMap();
    // }

    componentWillMount(){
        this.getAllBroadcastListings();
    }

    componentDidMount() {
        Bugsnag.leaveBreadcrumb("React for Broadcast Listings loaded");
    }

    componentWillUnmount() {

    }

    handleClickTab(title) {
        // important to mount map here
        if(title == "Locate By US Map"){
            this.mountMap();
        }

        title = encodeURIComponent(title);
        if(history.pushState) {
            history.pushState(null, null, '#'+title);
        }
        else {
            location.hash = '#'+title;
        }
        gtag('event', 'page_view', {
            'page_location': location.pathname+location.search+location.hash
        });
    }

    handleDropdownClick(thisHref, dropdownName) {
        // show selected name in dropdown in mobile mode
        // $('#listingDropdownMenu .dropdown-item').not($(this)).removeClass("active");
        // $('#listingDropdown').html($(this).html());
        // trigger tabs for dropdown in mobile mode

        $('#tablist a[href="' + thisHref + '"]').tab('show');

        // important to mount map here
        if(thisHref == "#usmap"){
            this.mountMap();
        }

        // change name
        this.setState({selectedDropdownName: dropdownName});

        var title = encodeURIComponent(dropdownName);
        if(history.pushState) {
            history.pushState(null, null, '#'+title);
        }
        else {
            location.hash = '#'+title;
        }
        gtag('event', 'page_view', {
            'page_location': location.pathname+location.search+location.hash
        });
    }

    render() {
        if(!this.state.isLoading){

            var posts = this.state.posts;
            var postsByState = this.state.postsByState;
            var stateID = this.state.stateID;
            var _self = this;

            // console.log(postsByState);

            return(
                <div>
                    <div className="nav-tabs--bg">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <ul className="nav nav-tabs hidden-sm-down" role="tablist" id="tablist">
                                        <li className="nav-item">
                                            <a className="nav-link active" data-toggle="tab" href="#all" role="tab" onClick={() => this.handleClickTab("All Listings")}>ALL</a>
                                        </li>
                                        {posts.map(function (item) {
                                            return (
                                                <li className="nav-item" key={item.id}>
                                                    <a className="nav-link" data-toggle="tab" href={ "#tab"+item.id } role="tab" onClick={() => _self.handleClickTab(item.title)}>{item.title}</a>
                                                </li>
                                            )
                                        })}

                                    </ul>

                                    <div className="broadcast__listings__dropdown dropdown hidden-md-up mt-2 mb-2">
                                        <button className="btn btn-white btn-block-mobile dropdown-toggle" type="button" id="listingDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {this.state.selectedDropdownName}
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="listingDropdown" id="listingDropdownMenu">
                                            <a className="dropdown-item" data-toggle="tab" href="#all" onClick={() => this.handleDropdownClick("#all", "All Listings")}>All Listings</a>
                                            {posts.map(function (item) {
                                                return (
                                                    <a className="dropdown-item" data-toggle="tab" href={ "#tab"+item.id } role="tab" key={item.id} onClick={() => _self.handleDropdownClick(item.id=='#usmap' ? item.id : "#tab"+item.id, item.title)}>{item.title}</a>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container broadcast__listings mb-2">
                        <div className="row">

                            <div className="tab-content col-12">
                                <div className="tab-pane active" id="all" role="tabpanel">
                                    {posts.map(function (item) { // render full table
                                        return (
                                        <div key={item.id}>
                                            <h2 className="h2 mb-1">{item.title}</h2>
                                            <ListingTable item={item.childrenPosts} />
                                        </div>
                                        )
                                    })}
                                </div>
                                <div className="tab-pane" id="usmap" role="tabpanel">
                                    <h2 className="h2">Locate by US Map</h2>

                                    <div id="mapWrapper">
                                        <div id="chartdiv"></div>
                                    </div>

                                    {(this.state.clickOnState && !this.state.isLoadingState) ?
                                        (this.state.postsByState != null) ? // show search state results
                                            <div>
                                                <h2 className="h2 mb-1">{postsByState.title}</h2>
                                                <ListingTable item={postsByState.childrenPosts} />
                                                {(posts.length > 0) ?
                                                    <div>
                                                        <h2 className="h2 mb-1">{posts[0].title}</h2>
                                                        <ListingTable item={posts[0].childrenPosts} />
                                                    </div>
                                                :''}
                                            </div>
                                           : // else show all USA National Listings
                                            <div>
                                                <h2 className="h2 mb-1">{stateID}</h2>
                                                <p>There are currently no listings for this state. You can also access our broadcast from one of the following channels below.</p>
                                                {(posts.length > 0) ?
                                                    <div>
                                                        <h2 className="h2 mb-1">{posts[0].title}</h2>
                                                        <ListingTable item={posts[0].childrenPosts} />
                                                    </div>
                                                :''}
                                            </div>
                                    :''}
                                    {(this.state.clickOnState && this.state.isLoadingState) ?
                                        <div className="mt-3 text-center">
                                            <i className="fa fa-circle-o-notch fa-spin"></i> Loading...
                                        </div>
                                    : ''}
                                </div>
                                {posts.map(function (item) { // render other tabs
                                    return (
                                        <div className="tab-pane" id={"tab" + item.id} role="tabpanel" key={item.id}>
                                            <h2 className="h2 mb-1">{item.title}</h2>
                                            <ListingTable item={item.childrenPosts} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="text-center mb-2 mt-2">
                    <i className="fa fa-circle-o-notch fa-spin" style={{fontSize: '24px'}}>
                    </i><br />Loading...
                </div>
            )
        }
    }
}

ReactDOM.render(<BroadcastListings/>, document.getElementById('broadcast-listings'));
